import { RevokeGoogleUserAuthorizationResultMutation as Mutation } from './mutation.generatedTypes'

interface ResponseArgsType {
   data: Mutation

   onHandleError: (
      errorMessage: string,
      data: Mutation['revokeGoogleAuthorization']
   ) => void

   onSuccess: () => void
}

interface ReturnType {
   handleAPIResponse: (args: ResponseArgsType) => void
}

const useResponseHandler = (): ReturnType => {
   const handleAPIResponse = (args: ResponseArgsType): void => {
      const { revokeGoogleAuthorization } = args.data

      switch (revokeGoogleAuthorization.__typename) {
         case 'RevokeGoogleUserAuthorizationResult': {
            const { isRevoked } = revokeGoogleAuthorization
            if (!isRevoked) break

            args.onSuccess()
            break
         }
         case 'GoogleAuthConsentNotGiven':
         default: {
            const errorType = revokeGoogleAuthorization.__typename
            const errorMessage = errorType
               ? errorType.replace(/([A-Z])/g, ' $1')
               : 'Unhandled Error Type'

            args.onHandleError?.(errorMessage, revokeGoogleAuthorization)
         }
      }
   }

   return { handleAPIResponse }
}

export default useResponseHandler
